
/** Enum for the left or right side of the body */
export enum Side {
    Left = 'left',
    Right = 'right',
}

const sides = ['left', 'right'] as const;

/** String-literal union for the left or right side of the body */
export type SideId = (typeof sides)[number];

export function isSideId(value: unknown): value is SideId {
    return sides.includes(value as SideId);
}

const clinicalSides = ['operative', 'contralateral'] as const;

/** String-literal union for the side of the body according to whether it is being operated on */
export type ClinicalSideId = typeof clinicalSides[number];

export function isClinicalSideId(value: unknown): value is ClinicalSideId {
    return clinicalSides.includes(value as ClinicalSideId);
}
